var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "77px",
    viewBox: "0 0 60 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31BA5DE5-63CF-4C6F-95A5-86B342500573@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tickets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tickets-Conversation---Upload-File",
    transform: "translate(-1049.000000, -444.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(767.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(22.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(260.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0547343,0 L8.63772455,0 C3.91046036,0 0,3.89034431 0,8.6176085 L0,68.0290981 C0,72.7563623 3.91046036,76.6467066 8.63772455,76.6467066 L51.2794723,76.6467066 C56.0067365,76.6467066 59.9162612,72.7563623 59.9162612,68.0290981 L59.9162612,20.8345808 L40.0547343,0 Z",
    id: "Path",
    fill: "#F3F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1520396,0.0584767665 L59.9363772,20.8537612 L46.7659993,20.8537612 C43.1090944,20.8537612 40.1520396,17.8971744 40.1520396,14.2402695 L40.1520396,0.0584767665 Z",
    id: "Path",
    fill: "#B7BFCA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.003181, 26.841879)",
    fill: "#708096"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4173737,28.3396228 L1.51254789,28.3396228 C0.680773892,28.3396228 1.43687531e-13,29.0203967 1.43687531e-13,29.8525345 C1.43687531e-13,30.6850362 0.680773892,31.36581 1.51254789,31.36581 L26.4326556,31.36581 C27.2647934,31.36581 27.9455673,30.6850362 27.9455673,29.8525345 C27.9455673,29.0203967 27.2647934,28.3396228 26.4173737,28.3396228 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21865646,12.0592668 L12.452231,5.35668242 L12.452231,21.8786385 C12.452231,22.7111402 13.1330049,23.3919141 13.9651427,23.3919141 C14.7972805,23.3919141 15.4784183,22.7111402 15.4784183,21.8786385 L15.4784183,5.35595476 L21.7119927,12.0592668 C22.0143567,12.3765489 22.4076846,12.5431948 22.8162945,12.5431948 C23.1797863,12.5431948 23.5574684,12.4071128 23.845642,12.134585 C24.4503701,11.5596931 24.4958521,10.6063913 23.9209602,10.0012994 L15.0698084,0.483927931 C14.7823624,0.181563886 14.3890345,8.28966525e-15 13.9655065,8.28966525e-15 C13.5416148,8.28966525e-15 13.1482868,0.181563886 12.8608409,0.483927931 L4.00968905,10.0012994 C3.43479707,10.6063913 3.4802791,11.574975 4.08500709,12.134585 C4.69046285,12.7094768 5.64340075,12.6639949 6.21865646,12.0592668 L6.21865646,12.0592668 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "56774c04b3440d8cd8f0d30a609229d8.svg";
export { ForwardRef as ReactComponent };